import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddOnsApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class AddOnsService {
  public apiUrl = 'add-ons';

  constructor(private readonly http: HttpClientService) {}

  public get(): Observable<AddOnsApiModel> {
    return this.http.get<AddOnsApiModel>(this.apiUrl);
  }
}
